import { store } from "@redux"

const doesItemExistInCart = (newOrderItem) => {
  const orderItems = store.getState().order.items

  const newOrderItemSpecificationItemsMap = {}

  newOrderItem.specificationItems.forEach(si => {
    newOrderItemSpecificationItemsMap[si._id] = si
  })

  const targetOrderItem =
    orderItems.find(cartItem => {
      if (cartItem.foodId !== newOrderItem.foodId) return false

      if (cartItem.optionId !== newOrderItem.optionId) return false

      if (cartItem.systemDiscount !== newOrderItem.systemDiscount) return false

      const specificationsMatch =
        cartItem.specificationItems.length === newOrderItem.specificationItems.length &&
        cartItem.specificationItems.every(si =>
          newOrderItemSpecificationItemsMap[si._id]?.quantity === si.quantity
        )

      if (!specificationsMatch) return false

      return true
    })

  if (!targetOrderItem) return null

  const newQuantity =
    Number(
      newOrderItem.quantity +
      targetOrderItem.quantity
    )

  return {
    ...targetOrderItem,
    quantity: newQuantity
  }
}

export default doesItemExistInCart